import React, { createContext, useContext, useEffect, useState } from 'react';
import api, { setToken } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const init = async () => {
      // Defer to a microtask so no state update runs synchronously within the effect.
      await Promise.resolve();
      const token = localStorage.getItem('vm_token');
      if (token) {
        setToken(token);
        try {
          const r = await api.get('/auth/me');
          if (active) setUser(r.data);
        } catch (e) {
          localStorage.removeItem('vm_token');
          setToken(null);
        }
      }
      if (active) setLoading(false);
    };
    init();
    return () => { active = false; };
  }, []);

  const persist = (data) => {
    localStorage.setItem('vm_token', data.access_token);
    setToken(data.access_token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    persist(r.data);
    return r.data.user;
  };

  const register = async (payload) => {
    const r = await api.post('/auth/register', payload);
    persist(r.data);
    return r.data.user;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch (e) { /* ignore */ }
    localStorage.removeItem('vm_token');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
